const pjson = require('../../package.json');

export const environment = {
    production: true,
    version: pjson.version,
    tenantId: 'yesacademy',
    server: {
        protocol: 'https',
        host: 'api.yesacademy.online',
        port: 443,
        apiPath: 'api/'
    },
    websocket: {
        host: 'api.yesacademy.online',
        port: 443
    },
    appTitle: "Yes Academy",
    configuration: <any>{},
    user: <any>{},
    swarmifyLoaded: false,
    websocketNotificationService: <any>Object,
    notificationService: <any>Object,
    userService: <any>Object,
    ImageAssets: <any>{},
    tt01DBVersion: 1,
    webDeviceUUID: "",
    features: {
        enableRooms: false,
        enableSubscription: false,
        enableRegistration: false
    },
    gtag: {
        enabled: false,
        gtmIframeID: "GTM-XXXXXXX",
        config1: "G-XXXXXXXXXX",
        config2: "G-YYYYYYYYYY"
    },
    iuBenda: {
        enabled: false,
        script1: {
            text: ``
        },
        script2: {
            src: ``
        }
    }
};